import { RefObject } from 'react';

/**
 * Cleans up audio resources
 */
// eslint-disable-next-line no-param-reassign
export function cleanupAudioResources(
  audioRef: RefObject<HTMLAudioElement | null>,
  recordedAudioURLRef: RefObject<string | null>,
  audioContextRef: RefObject<AudioContext | null>,
  audioBufferRef: RefObject<AudioBuffer | null>
): void {
  if (audioRef.current) {
    const audio = audioRef.current;

    if (!audio.paused) {
      audio.pause();
    }

    if (audio.src) {
      audio.src = '';
      audio.load();
    }

    // eslint-disable-next-line no-param-reassign
    audioRef.current = null;
  }

  if (recordedAudioURLRef.current) {
    const url = recordedAudioURLRef.current;

    if (url && typeof url === 'string' && url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }

    // eslint-disable-next-line no-param-reassign
    recordedAudioURLRef.current = null;
  }

  if (audioContextRef.current) {
    const context = audioContextRef.current;

    if (context.state !== 'closed') {
      context.close().catch(() => {});
    }

    // eslint-disable-next-line no-param-reassign
    audioContextRef.current = null;
  }

  // eslint-disable-next-line no-param-reassign
  audioBufferRef.current = null;
}

/**
 * Clears all pending timeouts
 */
/* eslint-disable no-param-reassign */
export function clearAllTimeouts(
  timeoutIdsRef: RefObject<ReturnType<typeof setTimeout>[]>
): void {
  timeoutIdsRef.current.forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  timeoutIdsRef.current = [];
}
